export interface MasterSubject {
    _id: string,
    name: string,
}

export interface MasterSubSubject {
    _id: string,
    name: string,
}

export interface MasterChapter {
    _id: string,
    name: string,
}

export interface MasterConcept {
    _id: string,
    name: string,
}

export interface MasterClass {
    _id: string,
    class: string,
}

export const MasterType = ['subject', 'sub-subject', 'chapter', 'concept'];

export const CodeInitials:any = {
    "class":"G",
    "subject": "S",
    "sub-subject": "SS",
    "chapter": "CH",
    "concept": "CO"
}